import {LinkProps} from 'next/link';
import Link from 'next/link';
import React, {HTMLAttributeAnchorTarget, PropsWithChildren} from 'react';

type OtherProps = {
  target?: HTMLAttributeAnchorTarget;
  href?: LinkProps['href'] | string;
  prefetch?: boolean;
};
type Props = Omit<LinkProps, 'href'> & OtherProps;

const LinkUI: React.FC<PropsWithChildren<Props>> = (props) => {
  const finalChildrens: React.ReactNode = props.children;
  if (!props.href) return <>{finalChildrens}</>;

  // Default to false to reduce unnecessary prefetch requests
  // Can be explicitly enabled with prefetch={true} where needed
  const shouldPrefetch = props.prefetch ?? false;

  return (
    <Link {...props} href={props.href} prefetch={shouldPrefetch}>
      {finalChildrens}
    </Link>
  );
};

export default LinkUI;
